import React, { useContext, useState } from 'react';
import LocaleContext from '../../contexts/LocaleContext';
import getText from '../../assets/locale/locale';
import './CopyLinkButton.scss';

const CopyLinkButton = () => {
  const locId = useContext(LocaleContext);
  const [isCopied, setIsCopied] = useState(false);
  function copyUrl() {
    navigator.clipboard.writeText(getText(locId, 'copiedUrl', 'resultsPage'));
    setIsCopied(true);
  }

  function copyTextHandler(textCopied: boolean): string {
    return textCopied
      ? getText(locId, 'linkCopiedSuccessfully', 'resultsPage')
      : getText(locId, 'copyLinkButton', 'resultsPage');
  }
  return (
    <button
      className="button button--secondary"
      type="button"
      onClick={copyUrl}
      data-testid="copyLink_btn"
    >
      <img
        src="/public/images/link-icon.png"
        alt=""
        role="presentation"
        className="copy-icon"
      />
      {copyTextHandler(isCopied)}
    </button>
  );
};

export default CopyLinkButton;
